import { createFileRoute, redirect } from '@tanstack/react-router'

type PostActionsSearch = {
  instanceId?: number
  packId?: number
  triggerType?: string
  jobType?: string
  templateId?: number
}

export const Route = createFileRoute('/_authenticated/settings/post-actions')({
  validateSearch: (search: Record<string, unknown>): PostActionsSearch => ({
    instanceId: search.instanceId ? Number(search.instanceId) : undefined,
    packId: search.packId ? Number(search.packId) : undefined,
    triggerType: search.triggerType as string | undefined,
    jobType: search.jobType as string | undefined,
    templateId: search.templateId ? Number(search.templateId) : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/automation/post-actions',
      search,
      replace: true,
    })
  },
})
